import { Link } from "react-router-dom";
import { Scale, PawPrint, Users, ShieldCheck } from "lucide-react";
import { LOGO_URL } from "@/data/constants";

export const Footer = () => {
  const values = [
    { Icon: Scale, text: "Truth. Awareness. Protection." },
    { Icon: PawPrint, text: "Supporting Responsible Ownership" },
    { Icon: Users, text: "Building a Stronger Community" },
    { Icon: ShieldCheck, text: "Advocating for a Brighter Future" },
  ];

  return (
    <footer className="bg-[#0A192F] text-white mt-20">
      {/* Values strip */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map(({ Icon, text }) => (
            <div key={text} className="flex items-center gap-3">
              <Icon className="w-6 h-6 text-[#D4AF37] shrink-0" aria-hidden="true" />
              <span className="overline text-white/90">{text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="bg-white inline-block p-3 rounded-sm">
            <img src={LOGO_URL} alt="Wolfdog News" className="h-16 w-auto object-contain" />
          </div>
          <p className="mt-4 text-sm text-white/60 leading-relaxed">
            An independent publication dedicated to up-to-date wolfdog news, legislation, and education.
          </p>
        </div>
        <FooterCol title="Explore" links={[["News", "/news"], ["Legislation", "/legislation"], ["Guest Articles", "/articles"], ["Information Hub", "/information"]]} />
        <FooterCol title="Community" links={[["Events", "/events"], ["Resources", "/resources"], ["About Us", "/about"], ["Contact", "/contact"]]} />
        <div>
          <h4 className="font-display text-lg font-bold text-[#D4AF37] mb-4">Newsroom</h4>
          <p className="text-sm text-white/60 leading-relaxed">
            Have a tip or a story? Reach our editorial desk through the{" "}
            <Link to="/contact" className="text-[#D4AF37] hover:underline">contact page</Link>.
          </p>
          <Link
            to="/admin"
            className="inline-block mt-4 overline text-white/40 hover:text-[#D4AF37] transition-colors"
            data-testid="footer-admin-link"
          >
            Editor Login (CMS)
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} WolfdogNews.com. All rights reserved.</span>
          <span>Truth. Awareness. Protection.</span>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="font-display text-lg font-bold text-[#D4AF37] mb-4">{title}</h4>
    <ul className="space-y-2">
      {links.map(([label, to]) => (
        <li key={to}>
          <Link to={to} className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors">
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
